// Pages
import RootPage from './Containers/Root';
import eCODEPage from './Containers/eCODE';

const routes = [
    {
        path: '/user',
        exact: false,
        strict: false,
        component: RootPage,
    },
    {
        path: '/eCODE',
        exact: false,
        strict: false,
        component: eCODEPage,
    }
];
export default routes;
